<template>
  <BaseDialog
    ref="baseDialog"
    modal-id="deleteTeacherDialog"
    :title="$t('teacher.deleteTitle')"
    :confirm-text="$t('common.delete')"
    confirm-variant="danger"
    @confirm="handleConfirm"
  >
    <template #body>
      <p>
        {{ $t('teacher.confirmDeleteMessage', { name: teacherName }) }}
      </p>
      <p class="text-danger">{{ $t('teacher.irreversible') }}</p>
    </template>
  </BaseDialog>
</template>

<script setup>
import { ref, defineEmits, defineExpose } from 'vue';
import BaseDialog from '@/components/common/BaseDialog.vue';

const baseDialog = ref(null);
const teacherName = ref('');
const teacherId = ref(null);

const open = (teacher) => {
  teacherName.value = teacher.username;
  teacherId.value = teacher.id;
  baseDialog.value?.openDialog();
};

const emit = defineEmits(['delete']);

const handleConfirm = () => {
  emit('delete', teacherId.value);
  baseDialog.value?.closeDialog();
};

defineExpose({ open });
</script>
